<template>
	<div class="row">
		<div class="col">
			<div class="form-group">
				<label for="adLogin">{{apiRequest.api}} ({{apiRequest.description}})</label>
				<select-group v-model="apiRequest.ad_login_id" :list="adLogins" :fieldValue="'id'"
				              :fieldText="'description'"
				              :disabled="isDisabled" id="adLogin">
					<option value="">-- {{'AD Login' | trans}} --</option>
				</select-group>
			</div>
			<div class="form-group">
				<spinner-button :className="'btn btn-info'" @click="submit($event)" :is-pending="isPending">
					{{'Complete' | trans}}
				</spinner-button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "api-ad-login",
		props: ['route', 'editRoute', 'adLogins'],
		data() {
			return {
				apiRequest: {},
				isPending: false,
				isDisabled: false,
				adLoginId: null
			};
		},
		mounted() {
			this.EventBus.$on('fillApiAdLoginForm', () => {
				this.apiRequest.id = this.$root.currentApiID;
				this.load();
			});
		},
		methods: {
			async submit(event) {
				event.stopPropagation();
				event.preventDefault();
				this.isPending = true;
				this.isDisabled = true;
				this.$store.commit(`formErrors/${this.CONSTANTS.MUTATIONS.CLEAR_ERRORS}`);
				await axios.post(this.route+'/'+this.apiRequest.id, this.apiRequest)
					.then(() => {
						this.EventBus.$emit('event-success', Lang.get('Success'));
						setTimeout(() => window.location.reload(), 1000);
					})
					.finally(() => {this.isPending = false; this.isDisabled=false;});
			},
			async load() {
				this.isPending = true;
				this.$store.commit(`formErrors/${this.CONSTANTS.MUTATIONS.CLEAR_ERRORS}`);
				let result = await axios.post(this.editRoute+'/'+this.apiRequest.id)
					.finally(() => {this.isPending = false; this.isDisabled=false;});
				this.apiRequest = result.data;
			}
		}
	}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/api-ad-login.vue